import React from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Sidebar from '../../Layout/Sidebar';

const SidebarLinks = ({ show, handleClose }) => {
    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Body>
                <Sidebar />
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default SidebarLinks;